/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCircleLetterP = createReactComponent("outline", "circle-letter-p", "IconCircleLetterP", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8", "key": "svg-1" }]]);

export { IconCircleLetterP as default };
//# sourceMappingURL=IconCircleLetterP.mjs.map
